import useAppState from "context/useAppState";
import { useState } from "react";

import chatCalenderIcon from "../../../assets/images/chat-box-calender-icon.svg";
import chatUserIcon from "../../../assets/images/chat-box-user-icon.svg";
import chatUploadIcon from "../../../assets/images/chat-box-upload-icon.svg";
import chatBellIcon from "../../../assets/images/chat-box-bell-icon.svg";
import Tooltip from "components/common/tooltip/Tooltip";
import FirstLineChips from "./chips/FirstLineChips";
import SecondLineChips from "./chips/SecondLineChips";
import ChatInput from "../Body/ChatInput";
import FooterDropdowns from "./Dropdown";
import { EVENT_PROGRAM_TITLE } from "utils/constant";
import { isNewFete } from "utils/fete";
import allImgPaths from "assets/images";
import SearchBarSuggestion from "./SearchBarSuggestion";

const ChatboxFooter = () => {

	const { setState: setChatBoxState } = useAppState("chatBox");
	const { selectedCardDetail } = useAppState('cardWrapper');
	const { showChatLoader } = useAppState('chatMessages');

	return (
		<div 
			className={`border border-[#EAECF0] px-6 rounded-bl-2xl rounded-br-2xl fetebuddy-footer-wrapper bg-[#f9fafb] ${showChatLoader ? 'disabled-chat-div' : ''} `}>

			<div className="fetebuddy-footer">
				{/* {!isNewFete() && (
					<>
						{selectedCardDetail?.title === EVENT_PROGRAM_TITLE && (
							// <FooterDropdowns />
						)}
					</>
				)} */}


				<div className="flex items-center justify-between pt-3 pb-1 relative">
					<ul className="flex gap-x-5 items-center flex-shrink-0">
						{/* Commenting below Code for R1 */}

						{/* <li className="relative group">
                    <img
                      className="w-5 h-5 flex-shrink-0 cursor-pointer"
                      src={chatTextIcon}
                      alt=""
                    />
                    <Tooltip
                      list={[
                        {
                          name: "Add Note",
                          _id: "1",
                        },
                      ]}
                      styles="bottom-full mb-2"
                      position="rotate-180 -bottom-2"
                    />
                  </li> */}

						<li className="relative group" onClick={() => setChatBoxState({ showDueDateModal: true })}>
							<img
								className="w-6 h-6 flex-shrink-0 cursor-pointer hover:bg-[#e6e7e8] p-0.5 rounded"
								src={chatCalenderIcon}
								alt=""
							/>
							<Tooltip
								list={[
									{
										name: "Add Due Date",
										_id: "2",
									},
								]}
								styles="bottom-full mb-2"
								position="rotate-180 -bottom-2"
							/>
						</li>

						<li className="relative group">
							<img
								className="w-6 h-6 flex-shrink-0 cursor-pointer hover:bg-[#e6e7e8] p-0.5 rounded"
								src={chatUserIcon}
								alt=""
								onClick={() => setChatBoxState({ showAssignModal: true })}
							/>
							<Tooltip
								list={[
									{
										name: "Assign Task",
										_id: "3",
									},
								]}
								styles="bottom-full mb-2"
								position="rotate-180 -bottom-2"
							/>
						</li>

						<li className="relative group" onClick={() => setChatBoxState({ showUploadFileModal: true })}>
							<img
								className="w-6 h-6 flex-shrink-0 cursor-pointer hover:bg-[#e6e7e8] p-0.5 rounded"
								src={chatUploadIcon}
								alt=""
							/>
							<Tooltip
								list={[
									{
										name: "Upload File",
										_id: "4",
									},
								]}
								styles="bottom-full mb-2"
								position="rotate-180 -bottom-2"
							/>
						</li>

						{/* <li className="relative group">
                    <img
                      className="w-5 h-5 flex-shrink-0 cursor-pointer"
                      src={chatBoxIcon}
                      alt=""
                    />
                    <Tooltip
                      list={[
                        {
                          name: "Add Comment",
                          _id: "5",
                        },
                      ]}
                      styles="bottom-full mb-2"
                      position="rotate-180 -bottom-2"
                    />
                  </li> */}

						{/* <li className="relative group">
                    <img
                      className="w-5 h-5 flex-shrink-0 cursor-pointer"
                      src={chatLinkIcon}
                      alt=""
                    />
                    <Tooltip
                      list={[
                        {
                          name: "Add Link",
                          _id: "6",
                        },
                      ]}
                      styles="bottom-full mb-2"
                      position="rotate-180 -bottom-2"
                    />
                  </li> */}

						<li className="relative group" onClick={() => setChatBoxState({ showRemainderModal: true })}>
							<img
								className="w-6 h-6 flex-shrink-0 cursor-pointer hover:bg-[#e6e7e8] p-0.5 rounded"
								src={chatBellIcon}
								alt=""
							/>
							<Tooltip
								list={[
									{
										name: "Add Reminder",
										_id: "7",
									},
								]}
								styles="bottom-full mb-2"
								position="rotate-180 -bottom-2"
							/>
						</li>
					</ul>
					{
						selectedCardDetail && <SearchBarSuggestion />
					}
				</div>

				{/* Chat Input */}
				<ChatInput />
			</div>

			{/* review Space Footer */}
			<div className="review-space-footer"></div>

			{/* Insight Footer */}
			<div className="py-2 flex justify-end insight-footer">
				<button className="submit-btn-blue gap-x-2 !px-14">
					Save
				</button>
			</div>

		</div>
	)
}

export default ChatboxFooter;